import { render } from "./m-desk.vue?vue&type=template&id=3b2d0592&scoped=true&ts=true"
import script from "./m-desk.vue?vue&type=script&lang=ts"
export * from "./m-desk.vue?vue&type=script&lang=ts"

import "./m-desk.vue?vue&type=style&index=0&id=3b2d0592&lang=scss&scoped=true"

import exportComponent from "D:\\project\\newb\\bnet2.0\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b2d0592"]])

export default __exports__